export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.7-1552.30",
  commitId: "3988216afbfbaae279b95b398c1aafc7d20d7ea9",
  commitTime: "2026-10-07T15:52:30.000Z",
});
